import { Button } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header";
import "./style.scss";
import { useTranslation } from "react-i18next";

export const Dashboard = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state: any) => state.user.user);
  const { firstName, lastName, role } = userInfo || {};
  const navigate = useNavigate();

  return (
    <>
      <Header title={t("dashboard.title")} />
      <div className="dashboard-wrapper">
        <p>
          {t("dashboard.welcome")},{firstName && <span> {firstName}</span>}{" "}
          {lastName && <span> {lastName}</span>} {t("dashboard.to")}
        </p>
        <div className="dashboard-action">
          {userInfo && role?.name !== "Service Provider Admin" && (
            <Button type="primary" onClick={() => navigate("/providers")}>
              {t("dashboard.viewProviders")}
            </Button>
          )}
          <Button onClick={() => navigate("/requests")}>
            {t("dashboard.viewRequests")}
          </Button>
        </div>
      </div>
    </>
  );
};
